import operasionalController from '../../../controllers/operasionalController/controller';
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default {
    name: 'SimpleTable',
    data(){
        return {
            company: '' ,
            operasionalList: [],
            currentPage: 1,
            pageSize: 10,
            totalOperasional: 0,
            totalPages: 0,
            searchQuery: '',
            iconSearch: '',
            allIcons: [],
            icons: [],
            dropdownOpen: false,
            operasional: {
                name: '',
                qty: '',
                icon: '',
                language: '',
                company: '',
                status: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedOperasional: {
                updated_by: '',
                updated_by_name: '',
                updated_on: '',
            }
        }
    },
    computed:{
        filteredOperasional(){
            return this.operasionalList.filter(operasional => operasional.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalOperasional / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
        showModal(type, id) {
            this.user()
            const operasional = this.operasionalList.find(operasional => operasional.id === id);
            if (operasional) {
                this.operasional = operasional;
                
                const modal = document.getElementById(type === 'edit' ? 'editOperasional' : 'detailOperasional');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
            const modalIds = ['tambahOperasional', 'editOperasional', 'detailOperasional'];
            this.resetForm();
            modalIds.forEach(id => {
              const modal = document.getElementById(id);
              if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                  modal.style.display = 'none';
                }, 300);
              }
            });
          
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
              backdrop.classList.remove('show');
              setTimeout(() => {
                if (backdrop.parentNode) {
                  backdrop.parentNode.removeChild(backdrop);
                }
              }, 300);
            });
          
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchOperasional();
        },  
        resetForm() {
            this.operasional.name = '';
            this.operasional.qty = '';
            this.operasional.icon = '';
            this.operasional.language = '';
            this.operasional.status = '';
            this.iconSearch = '';
            this.icon();
        },
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.operasional.created_by = id;
            this.selectedOperasional.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.selectedOperasional.updated_by_name = name;
            this.operasional.created_by_name = name;
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchOperasional();
            }
        },
        async fetchOperasional(){
            try{
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await operasionalController.fetchOperasional(query, this.currentPage, this.pageSize, this.company);
                this.operasionalList = response.data;
                this.totalAllOperasional();
            } catch (error) {
                console.error('Error fetching operasional:', error);
                throw error;
            }
        },
        async totalAllOperasional() {
            try {
                const company_id = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await operasionalController.totalALlOperasional(query, company_id);
                this.totalOperasional = response.data;
            } catch (error) {
                console.error('Error fetching operasional:', error);
                throw error;
            }
        },
        async addOperasional(){
            try {
                const name = this.operasional.name;
                const qty = this.operasional.qty;
                const icon = this.operasional.icon;
                const language = this.operasional.language;
                const status = this.operasional.status;
                const company = this.company;
                const created_by = this.operasional.created_by;
                const created_by_name = this.operasional.created_by_name;
                if (!name || !qty || !icon || !status || !language || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    });
                    return;
                }
                const now = new Date();
                const created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const add = {
                    name: name,
                    qty: qty,
                    icon: icon,
                    language: language,
                    id_company: company,
                    is_active: status,
                    created_by: created_by,
                    created_by_name: created_by_name,
                    created_on: created_on
                }
                const response = await operasionalController.addOperasional(add);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil menambahkan data',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.closeModal();
                    this.resetForm();
                    this.fetchOperasional();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    time: 1500
                })
            }
        },
        async updateOperasional(){
            try{
                const id = this.operasional.id;
                const name = this.operasional.name;
                const qty = this.operasional.qty;
                const language = this.operasional.language;
                const icon = this.operasional.icon;
                const status = this.operasional.status;
                const updated_by = this.selectedOperasional.updated_by;
                const updated_by_name = this.selectedOperasional.updated_by_name;
                const now = new Date()
                const updated_on = now.toISOString().slice(0,19).replace('T', ' ');   
                if (!id || !name || !qty || !icon || !language || !status ) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    });
                }  
                const update = {
                    id: id,
                    name: name,
                    qty: qty,
                    icon: icon,
                    language: language,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                };
                const response = await operasionalController.updateOperasional(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Operasional berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchOperasional();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal memperbaharui data',
                    time: 1500
                })
                throw error;
            }
        },
        async deleteOperasional(id){            
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await operasionalController.deleteOperasional(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Operasional berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchOperasional();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        text: error.message,
                        time: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
        async icon(){
            const res = await fetch('https://raw.githubusercontent.com/twbs/icons/main/font/bootstrap-icons.json');
            const data = await res.json();
            this.allIcons = Object.keys(data).map(name => `bi bi-${name}`);
            this.icons = this.allIcons;
        },
        selectIcon(icon) {
            this.operasional.icon = icon;
            this.dropdownOpen = false;
        },
        searchIcon() {
            const keyword = this.iconSearch.toLowerCase();
            this.icons = this.allIcons.filter(icon =>
                icon.toLowerCase().includes(keyword)
            );
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        this.icon();
        this.icons = this.allIcons; 
    },
    watch :{
        searchQuery: {
            handler: 'fetchOperasional'
        },
        company: {
            handler: 'fetchOperasional'
        }
    },
    created() {
        this.icons = this.allIcons; // Awal: tampilkan semua
    },
}